<template>
  <div class="page">
    <div class="result">
      <img src="./images/result-bg.jpg" class="img-fluid" />


      <div class="result__info">
        <router-link :to="{ name: 'LiffProjAbbottAnd2026LotteryQ2EarnCount', query: { event_code: 'e2026Q2' } }">
          <img src="./images/result-btn.png" class="img-fluid" />
        </router-link>
        
      </div>

    </div>
  </div>
</template>
<script>
export default {

}
</script>

<style lang="scss" scoped>
.result {
  position: relative;
}

.result__info {
  position: absolute;
  bottom: 2%;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}
</style>
